import configLib from '../../../configLib';
import { GWQueryCase } from '../../models/gateway/types';
import { QueryCacheItemType } from '../../models/trading/types';
import { dataQuery } from '../../store/gateway';
import { REST_RETRIES_QUICK_DELAY } from '../../store/gateway/constants';
import { WebSocketEventData } from '../custom-event/types';
import { LoggerService } from '../logger/Logger.service';
import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseSubscriptionService } from './BaseSubscription.service';
import { DEFAULT_NEWS_PAGE_NUMBER, DEFAULT_NEWS_PAGE_SIZE } from './constants';
import { NewsSubscriptionRequestType } from './types';

const LOG_PREFIX = '[NEWS-SUBS]';
const logger = LoggerService.getLogger();

/**
 * News Subscription Service
 */
export class NewsSubscriptionService extends BaseSubscriptionService<NewsSubscriptionRequestType> {
  private static instance: NewsSubscriptionService;

  // Make the constructor private, to have a single instance
  // eslint-disable-next-line no-useless-constructor
  private constructor() {
    super();
  }

  static getInstance(): NewsSubscriptionService {
    if (!this.instance) {
      this.instance = new NewsSubscriptionService();
    }

    return this.instance;
  }

  public subscribe(): void {
    const subscripitonRequest = this.subscripitonRequests[0];
    if (subscripitonRequest) { // This news request already in the subscription request list!
      return;
    }

    const request = {
      pageSize: DEFAULT_NEWS_PAGE_SIZE,
      pageNumber: DEFAULT_NEWS_PAGE_NUMBER,
      ...this.getDefaultRequestParams(),
    };

    this.subscripitonRequests.push(request);
    this.gatewayService.sendRequest(request);
  }

  public subscribeList = (item: string[], args: any): void => {
    // There is no such need right now
    throw new Error('Not implemented yet!');
  };

  public unsubscribe(): void {
    const subscripitonRequest = this.subscripitonRequests[0];
    if (!subscripitonRequest) { // This now news request in the subscription request list!
      return;
    }

    if (this.shouldDebounce(subscripitonRequest)) {
      return;
    }

    this.subscripitonRequests = [];// to remove news request from the list
  }

  public unsubscribeList = (item: string[], args: any): void => {
    // There is no such need right now
    throw new Error('Not implemented yet!');
  };

  // TODO: HW-1162  Cover all cases with unittesting
  public handleResponseEvent(event: WebSocketEventData<any>): void {
    const data = event.data ?? {};

    const {
      accessId,
      traceIdentifier,
    } = data || {};
    const traceIdentifierRequest = (this.gatewayService.getRequestedObjectList().find(
      item => item.messageType === this.getSubscriptionRequestType()
        && item.traceIdentifier === traceIdentifier,
    ) ?? {}) as NewsSubscriptionRequestType;

    const cacheData: QueryCacheItemType = {
      queryCase: GWQueryCase.News,
      symbol: null,
      requestData: traceIdentifierRequest,
    };

    configLib.store.dispatch(dataQuery({
      accessId,
      traceIdentifier,
      estimatedDeliveryInSec: REST_RETRIES_QUICK_DELAY,
      cacheData,
    }));
  }

  protected getResponseType = (): GatewayResponseType => GatewayResponseType.DataQueryResponse;

  protected getSubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.GetLatestNewsArticles;

  protected getUnsubscriptionRequestType = (): GatewayRequestType => GatewayRequestType.GetLatestNewsArticles;
}
